import { usersApiClient } from './api';
import authService from './authService';

// Simple game result interface that matches iOS app and production API
export interface GameResult {
  pointsEarned: number;
  correctAnswers: number;
  totalQuestions: number;
  difficulty: string;
  // Prefer bestStreak; keep streak optional for backward compatibility
  bestStreak?: number;
  streak?: number;
}

export interface GameResultResponse {
  user: {
    auth0Id: string;
    email: string;
    name: string;
    picture?: string;
    displayName?: string;
    totalPoints: number;
    gamesPlayed: number;
    correctAnswers: number;
    totalAnswers: number;
    bestStreak: number;
    currentLevel?: number;
    currentRank?: string;
    currentTier?: string;
  };
  gameResults?: {
    pointsEarned: number;
    newTotalPoints: number;
    leveledUp: boolean;
    oldRank?: any;
    newRank?: any;
  };
}

const gameService = {
  // Submit game results to match iOS app pattern
  submitGameResults: async (gameResult: GameResult): Promise<GameResultResponse> => {
    try {
      const accessToken = authService.getAccessToken();
      if (!accessToken) {
        throw new Error('No authentication token found');
      }

      // Get the current user's auth0Id to include in the request
      const currentUser = authService.getCurrentUser();
      if (!currentUser || !currentUser.auth0Id) {
        throw new Error('User not authenticated or auth0Id missing');
      }

      // Include auth0Id as query parameter as expected by backend
      const response = await usersApiClient.post<GameResultResponse>(
        `/users/game-results?auth0Id=${encodeURIComponent(currentUser.auth0Id)}`,
        gameResult
      );

      return response.data;
    } catch (error) {
      console.error('Failed to submit game results:', error);
      throw error;
    }
  }
};

export default gameService;